import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { BASE_BFF_WEB_URL } from "utilities/Constant";

export interface LoginData {
  emailaddress: string;
  password: string;
}

export interface AuthenticationResponse {
  flowId: string;
  _embedded: {
    devices: AuthDeviceDetails[];
  }
  status: string;
  id: string;
  accessToken: string;
  name: string;
  refreshToken: string;
  version: string;
}

export interface AuthDeviceDetails {
  id: string;
  type: string;
  phone?: string;
  email?: string;
}

export const loginApi = createApi({
  reducerPath: "loginApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_BFF_WEB_URL, credentials: "include" }),
  endpoints: (build) => ({
    postLogin: build.mutation<AuthenticationResponse, LoginData>({
      query: (body: LoginData) => ({
        url: "/Account/login",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { usePostLoginMutation } = loginApi;
